import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ee from "./assets/i18n/translation_ee.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ee",
    lowerCaseLng: true,
    resources: {
      ee: {
        translation: ee,
      },
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "locale",
    },
  });

export default i18n;
